import BPIcon from 'components/BionicUI/icons/BPIcon';
import BPIconButton from 'components/BionicUI/icons/BPIconButton';
import {
  GetUserProjectsRequest,
  GetUserProjectsResponseItem,
} from 'core/models/users/project/get-user-projects.model';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
import React, { FC, useEffect, useRef, useState } from 'react';
import { ROUTES } from 'routes';

const ProjectsNav: FC = () => {
  const [projects, setProjects] = useState<GetUserProjectsResponseItem[]>([]);
  const [offset, setOffset] = useState<number>(0);
  const sliderWindow = useRef<HTMLDivElement>(null);
  const slider = useRef<HTMLDivElement>(null);

  const prev = () => {
    const slideDistance = sliderWindow.current
      ? sliderWindow.current.clientWidth * 0.8
      : 0;
    setOffset(Math.max(0, offset - slideDistance));
  };

  const next = () => {
    const slideDistance = sliderWindow.current
      ? sliderWindow.current.clientWidth * 0.8
      : 0;
    setOffset(
      Math.min(
        offset + (sliderWindow?.current?.clientWidth ?? 0),
        offset + slideDistance
      )
    );
  };

  useEffect(() => {
    async function fetchProjects() {
      const request: GetUserProjectsRequest = {};
      const response = await new UserV1BaseServerRepo().getProjects(request);
      setProjects(response);
    }
    fetchProjects();
  }, []);

  return (
    <div className="flex relative grid-flow-col gap-2">
      <HomeButton />
      {projects.length ? (
        <div
          ref={sliderWindow}
          className="grid relative w-full h-auto overflow-hidden animate-fade-in"
        >
          <Slider projects={projects} offset={offset} ref={slider} />
          {(slider.current?.clientWidth ?? 0) >
            (sliderWindow.current?.clientWidth ?? 0) && (
            <ArrowButtons
              prev={prev}
              next={next}
              offset={offset}
              sliderWindowWidth={sliderWindow.current?.clientWidth ?? 0}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};

const ArrowButtons: FC<{
  prev: () => void;
  next: () => void;
  offset: number;
  sliderWindowWidth: number;
}> = ({ prev, next, offset, sliderWindowWidth }) => {
  return (
    <div className="grid absolute grid-cols-2 top-0 left-0 w-full h-full pointer-events-none ">
      <div className="grid relative items-center">
        {offset > 0 ? (
          <>
            <div className="block absolute top-0 left-0 w-[100px] h-full bg-gradient-to-l from-[#04040600] to-[#040406] " />
            <BPIconButton icon="backArrow" onClick={() => prev()} small />
          </>
        ) : null}
      </div>
      <div className="grid relative items-center justify-end">
        {offset <= sliderWindowWidth ? (
          <>
            <div className="block absolute top-0 right-0 w-[100px] h-full bg-gradient-to-r from-[#04040600] to-[#040406] " />
            <BPIconButton icon="rightArrow" onClick={() => next()} small />
          </>
        ) : null}
      </div>
    </div>
  );
};

// React.forwardRef<HTMLButtonElement, ButtonProps>(
//  ({ className, variant, size, asChild = false, ...props }, ref) => {

interface SliderProps {
  projects: GetUserProjectsResponseItem[];
  offset: number;
}

const Slider = React.forwardRef<HTMLDivElement, SliderProps>(
  ({ projects, offset }, ref) => (
    <div
      id="search-projects-slider"
      className="block absolute whitespace-nowrap transition-transform duration-300"
      style={{
        transform: `translateX(-${offset}px)`,
      }}
      ref={ref}
    >
      {projects.map((project, idx) => (
        <a
          key={`project_button_${idx}`}
          href={ROUTES.PROJECT.replace(':id', project.id)}
          className="inline-grid grid-cols-[auto_1fr] gap-2 relative text-[14px] items-center pl-2 pr-4 py-[6px] mr-2 rounded-l-full no-underline rounded-r-full border border-[#ffffff40] hover:bg-white/20 hover:opacity-100 whitespace-nowrap overflow-hidden"
        >
          {project.logo ? (
            <img
              src={project.logo}
              alt={project.name}
              className="w-[22px] h-[22px] overflow-hidden rounded-[4px] object-cover border border-white/20"
            />
          ) : null}
          <div>{project.name}</div>
        </a>
      ))}
    </div>
  )
);

Slider.displayName = 'Slider';

const HomeButton = () => (
  <a
    href="/dashboard"
    className="grid relative w-[36px] h-[36px] aspect-square justify-center items-center border border-[#ffffff40] rounded-[4px] hover:bg-white/20"
  >
    <BPIcon icon="home" className="fill-white" />
  </a>
);

export default ProjectsNav;
